import {Link} from "@inertiajs/react";
import styles from './Breadcrumbs.module.scss'
import {faChevronLeft} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Section, {SectionProps} from "@/Molecules/Section";
import React from "react";

type Breadcrumb = {
  title: string;
  route?: string;
}

export type BreadcrumbProps = {
  items: Breadcrumb[];
  side?: React.ReactNode;
} & SectionProps

export default ({items, side, ...sectionProps}: BreadcrumbProps) => {

  return <Section lighter {...sectionProps} contentClassName={styles.container}>
    <nav aria-label="Breadcrumb" className={styles.breadcrumbs}>
      <ol>
        {items.map((item, index) => {
          const isLast = index === items.length - 1

          return <li key={`${item.title}-${index}`}>
            {item.route && !isLast ? <Link href={item.route}>
              {item.title}
            </Link> : <span aria-current={isLast ? 'page' : undefined}>
            {item.title}
          </span>}

            {!isLast && <span aria-hidden="true"> <FontAwesomeIcon icon={faChevronLeft}/> </span>}
          </li>
        })}
      </ol>
    </nav>
    {side}
  </Section>
}